export default __webpack_public_path__ + "static/media/Frame_183.7a5732b5.jpg";